import { useMutation } from '@tanstack/react-query';
import userProfileService from '@/services/userProfile.service';

export const usePublicTokenMutation = () => {
  return useMutation({
    mutationFn: () => userProfileService.getPublicToken(),
  });
};
